import {Actions} from '../../constants/permissions/actions';
import {Roles, TeamRoles} from '../../constants/roles';
import {can} from '../../services/permissions';

export function useUserPermission(role: string, teamRoles: TeamRoles[] = []) {
  const updatedRole =
    Object.values(Roles).find((roleFromConstant) => {
      return roleFromConstant === role;
    }) ?? Roles.MEMBER;

  return (action: Actions) => {
    return can(action, [updatedRole, ...teamRoles]);
  };
}
